import { render, staticRenderFns } from "./societes.vue?vue&type=template&id=9fddd54e&"
import script from "./societes.vue?vue&type=script&lang=ts&"
export * from "./societes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports